import './CFAdminAttributes.scss';
import {Formik} from 'formik'
import * as Yup from 'yup';
import {FVPHiddenInput, FVPTextInput} from '../../components/formField';

import VehicleConfigService from '../../services/VehicleConfigService';
import CFAdminConfirmDialog from "../../components/CFAdminConfirmDialog";
import React, {useState} from "react";

const schema = Yup.object().shape({
    attributeValueDescription: Yup.string()
        .required("Description is a required field")
        .min(1, "Description must be at least 1 character")
        .max(200, "Description must be at most 200 characters"),
    attributeId: Yup.number().required()
});

type Props = Readonly<{
    attributeValueId?: number | null;
    attributeId: number;
    attributeValueDescription?: string;
    toggleModal: any;
    refreshData: any;
    successMessage: any;
    errorMessage: any;
    isDelete?: boolean;
}>;

function CFAdminAttributeValueForm({
                                       attributeValueId,
                                       attributeId,
                                       attributeValueDescription,
                                       toggleModal,
                                       refreshData,
                                       successMessage,
                                       errorMessage,
                                       isDelete
                                   }: Props) {
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

    const saveOperation = (values: any) => {
        const data = {
            attributeId: Number(values.attributeId),
            attributeValueDescription: values.attributeValueDescription
        };
        VehicleConfigService.createVehicleAttributeValue(data)
            .then(() => {
                successMessage(`Attribute Value: ${values.attributeValueDescription} added successfully.`);
                refreshData();
                toggleModal();
            })
            .catch(e => {
                errorMessage(e?.response?.data?.errorMessage || 'Error while creating attribute value');
            });
    };

    const updateOperation = (values: any) => {
        VehicleConfigService.updateVehicleAttributeValue(values.attributeValueId, values.attributeValueDescription)
            .then(() => {
                successMessage(`Attribute Value: ${values.attributeValueDescription} updated successfully.`);
                refreshData();
                toggleModal();
            })
            .catch(e => {
                errorMessage(e?.response?.data?.errorMessage || 'Error while updating attribute value');
            });
    };

    const deleteOperation = (values: any) => {
        VehicleConfigService.deleteVehicleAttributeValue(values.attributeValueId)
            .then(() => {
                successMessage(`Attribute Value: ${values.attributeValueDescription} deleted successfully.`);
                refreshData();
                toggleModal();
            })
            .catch(e => {
                errorMessage(e?.response?.data?.errorMessage || 'Error while deleting Attribute Value!');
            });
    };

    return (
        <>
            <Formik
                validationSchema={schema}
                initialValues={{
                    attributeValueId: attributeValueId,
                    attributeId: attributeId,
                    attributeValueDescription: attributeValueDescription || ''
                }}
                onSubmit={(values) => {
                    if (isDelete) {
                        setIsDeleteConfirmOpen(true);
                    } else if (values.attributeValueId !== undefined && values.attributeValueId !== null) {
                        updateOperation(values);
                    } else {
                        saveOperation(values);
                    }
                }}
            >
                {({
                      //values,
                      //errors,
                      //touched,
                      //handleChange,
                      //handleBlur,
                      handleSubmit,
                      isValid,
                      dirty
                  }) => (
                    <div className="fvp-form">
                        <div>
                            <form data-testid="SubmitForm" noValidate onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div className="fvp-form__group">
                                        <FVPHiddenInput name="attributeValueId"/>
                                        <FVPHiddenInput name="attributeId"/>
                                        <FVPTextInput label="Attribute Value Description:"
                                                      name="attributeValueDescription" required readOnly={isDelete}
                                                      disabled={isDelete}/>
                                    </div>
                                </div>
                                <div className="modal-footer button-frame">
                                    <button
                                        data-testid="Cancel"
                                        className="fvp-button--outline"
                                        onClick={toggleModal}>
                                        <i className="fvp-left-chevron"/>{' '}
                                        Cancel
                                    </button>
                                    {isDelete ? (
                                        <button
                                            data-testid="Delete"
                                            className="fvp-button-danger--outline"
                                            type="submit">
                                            Delete{' '}
                                            <i className="fvp-right-chevron"/>
                                        </button>
                                    ) : (
                                        <button
                                            data-testid="Save"
                                            className="fvp-button"
                                            type="submit"
                                            disabled={!(dirty && isValid)}>
                                            Save{' '}
                                            <i className="fvp-right-chevron"/>
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </Formik>

            <CFAdminConfirmDialog
                isOpen={isDeleteConfirmOpen}
                onClose={() => setIsDeleteConfirmOpen(false)}
                onConfirm={() => deleteOperation({
                    attributeValueId,
                    attributeId,
                    attributeValueDescription
                })}
                title={"Delete Attribute Value: " + (attributeValueDescription || '')}
                text="Are you sure you want to delete this Attribute Value?"
            />
        </>
    );
}

export default CFAdminAttributeValueForm;
